var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/header/cart-count.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
if((lineno = 0, colno = 17, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "core"),"cart.bagCount",0])) > 99) {
output += "\n\n    <span class=\"u-extra-small--hide c-cart__product-count c-cart__product-count--show js-ucc-cart-count-large\" data-qa-cart-count aria-label=\"product count\">\n        ";
output += runtime.suppressValue((lineno = 3, colno = 10, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["bag-count_max-count"])), env.opts.autoescape);
output += "\n    </span>\n    <span class=\"u-large--hide c-cart__product-count js-ucc-cart-count-small\" data-qa-cart-count aria-label=\"product count\">+</span>\n";
;
}
else {
output += "\n    <span class=\"u-extra-small--hide c-cart__product-count c-cart__product-count--show js-ucc-cart-count-large\" data-qa-cart-count aria-label=\"";
output += runtime.suppressValue((lineno = 7, colno = 145, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["cart-count-shopping-cart-product-count"])), env.opts.autoescape);
output += "\">\n        ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"cart")),"bagCount"), env.opts.autoescape);
output += "\n    </span>\n    <span class=\"u-large--hide c-cart__product-count js-ucc-cart-count-small\" data-qa-cart-count aria-label=\"";
output += runtime.suppressValue((lineno = 10, colno = 111, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["cart-count-shopping-cart-product-count"])), env.opts.autoescape);
output += "\">+</span>\n\n";
;
}
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/header/cart-count.j2"] , dependencies)